import React from "react";
import { useStatisticsPeriodStore } from "@/store/statisticsPeriodStore";
import cls from "./styles.module.scss";
import { RegisteredStep } from "./RegisteredStep";
import { Goal5Step } from "./Goal5Step";
import { Goal30Step } from "./Goal30Step";

export const GoalsFunnel = () => {
  const mode = useStatisticsPeriodStore((s) => s.mode);
  const isCompletionMode = mode === "completion";

  return (
    <>
      <div className={cls.block}>
        <div className={cls.blockHead}>
          <div className={cls.blockTitle}>Кто дошёл до целей</div>
          <div className={cls.blockSubtitle}>
            {isCompletionMode
              ? "по периоду выполнения"
              : "по периоду регистрации"}
          </div>
        </div>

        <div>
          <RegisteredStep />
          <Goal5Step />
          <Goal30Step />
        </div>
      </div>
    </>
  );
};
